import { combineEpics } from 'redux-observable';

import RouterRootEpics from 'components/RouterRoot/epics';

export const componentsEpics = combineEpics(RouterRootEpics);
